<app-header></app-header>
<app-sidebar></app-sidebar>

<div class="content-wrapper" style="min-height: 307px">
   <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="false">
      <p style="color: white">Loading... </p>
   </ngx-spinner>
   <section id="credit">
      <div class="card">
         <div class="card-header">
            <div class="row">
               <div class="col" style="text-align: center;">
                  <h2>สัญญาปี 25{{year.substr(0,2)}}/25{{year.substr(2,2)}}</h2>
               </div>
               <div class="col">
                  <!-- Nav tabs -->
                  <ul class="nav nav-pills mb-3 d-flex align-items-center" id="myTab" role="tablist">
                     <li class="nav-item" role="presentation">
                        <a class="btn btn-outline-success" [ngClass]="{'active':id == 1}"
                           (click)="chagetab(1);">เพิ่มข้อมูล</a>
                     </li>
                     <li class="nav-item">
                        <a class="btn btn-outline-secondary" [ngClass]="{'active':id == 2}"
                           (click)="chagetab(2);">ยังไม่ตรวจสัญญา</a>
                     </li>
                     <li class="nav-item" role="presentation">
                        <a class="btn btn-outline-secondary" [ngClass]="{'active':id == 3}"
                           (click)="chagetab(3);">ตรวจสัญญาแล้ว</a>
                     </li>
                     <li class="nav-item" role="presentation">
                        <a class="btn btn-outline-secondary" [ngClass]="{'active':id == 4}"
                           (click)="chagetab(4);">ข้อมูลทั้งหมด</a>
                     </li>
                     <li class="nav-item" role="presentation">
                        <a class="btn btn-link " [ngClass]="{'disabled':id == 1}" (click)="goloadpromiseall();">
                           <i class="fas fa-retweet"></i>โหลดข้อมูลใหม่</a>
                     </li>
                  </ul>
               </div>
            </div>
         </div>

         <!-- navbar -->
         <!-- หน้าเพิ่มข้อมูล -->

         <div class="row" [hidden]="id!=1">
            <div class="col-lg-6">
               <div class="card">
                  <div class="card-body">
                     <form [formGroup]="FormFirst">
                        <div class="input-group mb-3">
                           <span class="input-group-text">เลือกชาวไร่ <mat-icon>person</mat-icon></span>
                           <input type="text" class="form-control" list="farmerdata" formControlName="fullname"
                              (change)="Toformdata();">
                           <datalist id="farmerdata">
                              <option *ngFor="let item of Selectfarmer">[{{item.fmcode_b1}}] ,{{item.fmname}} ,พื้นที่
                                 {{item.area|number}} ไร่
                                 <label *ngIf="item.PromiseIN ==0">สัญญายังไม่ผ่าน</label>
                                 <label *ngIf="item.zoneban ==='Y'">อยู่โซนต้องห้าม</label>
                              </option>
                           </datalist>
                           <!-- <select class="form-control"> <option value="">เลือกข้อมูล</option></select> -->
                        </div>
                        <div *ngIf="form.fullname.errors?.required">
                           <p style="color: red;">กรุณาเลือกชาวไร่ เช่น [0000122071] นางกองแบ้ง ชะภูมิรัมย์</p>
                        </div>

                        <div class="input-group mb-3">
                           <span class="input-group-text"> <mat-icon>contact_mail</mat-icon> เลขบัตร </span>
                           <input type="text" class="form-control" formControlName="idcard"
                              placeholder="ระบุเลขบัตรประชาชน"
                              onkeypress='return event.charCode >= 48 && event.charCode <= 57' id="cardid" required
                              [ngClass]="{ 'is-invalid': submitted && form.idcard.errors }">
                           <span class="input-group-text"> <mat-icon>event</mat-icon> วันเกิด </span>
                           <input type="text" class="form-control" formControlName="birthday"
                              placeholder="ระบุวันเกิด ตัวอย่าง 25/10/2510" maxlength="10"
                              [ngClass]="{ 'is-invalid': submitted && form.birthday.errors }">
                        </div>
                        <div *ngIf="submitted && form.idcard.errors?.required">
                           <p style="color: red;">กรุณาระบุวันเลขบัตรประจำตัวประชาชน</p>
                        </div>
                        <div *ngIf="submitted && form.birthday.errors?.required">
                           <p style="color: red;">กรุณาระบุวันเดือนปีเกิด </p>
                        </div>
                        <div *ngIf="form.birthday.errors?.minlength">
                           <p style="color: red;">กรุณาระบุวันเดือนปีเกิด เช่น 10/10/2510 ถ้าเป็น 1/1/1900 กรุณากรอก
                              01/01/2443</p>
                        </div>
                        <div *ngIf="form.birthday.errors?.pattern">
                           <p style="color: red;">กรุณากรอกแบบ ปี พ.ศ. เช่น 10/10/2510 </p>
                        </div>
                        <div class="input-group mb-3">
                           <span class="input-group-text"> <mat-icon>person</mat-icon></span>
                           <input type="text" class="form-control" value="{{fullname}}" disabled id="fullname">
                           <span class="input-group-text"> <mat-icon>local_shipping</mat-icon></span>
                           <input type="text" class="form-control" disabled>
                           <span class="input-group-text"> <mat-icon>groups</mat-icon></span>
                           <input type="text" class="form-control" disabled>
                        </div>
                        <div class="input-group mb-3">
                           <span class="input-group-text">เบอร์โทร</span>
                           <input type="text" class="form-control" formControlName="fmtel" minlength="10" maxlength="10"
                              onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                              placeholder="อย่างน้อย 1 หมายเลข เช่น 0987654321"
                              [ngClass]="{ 'is-invalid': submitted && form.fmtel.errors?.required }">
                           <span class="input-group-text">วันที่ทำสัญญา ({{date_add|adtob}})</span>
                           <input [(ngModel)]="date_add" [ngModelOptions]="{standalone: true}" type="date"
                              class="form-control" required>
                        </div>
                        <div *ngIf="submitted && form.fmtel.errors" class="invalid-feedback">
                           <div *ngIf="form.fmtel.errors?.required">กรุณาระบุเบอร์โทร</div>
                        </div>
                        <div *ngIf="form.fmtel.errors?.minlength">
                           <p style="color: red;">กรุณากรอกเบอร์โทรอย่างน้อย 1 หมายเลข (10 ตัว)</p>
                        </div>
                        <div class="input-group mb-3">
                           <button class="btn btn-info" (click)="InsertCredit();">ใช้หลักทรัพย์</button>
                        </div>
                        <div class="input-group mb-3">
                           <label style="color: red;">เฉพาะกรณีชาวไร่ใช้หลักทรัพย์ที่ไม่ใช่ชื่อตนเองค้ำประกัน แค่คีย์
                              วันเดือนปีเกิดและเลขบัตรประชาชนและแนบสัญญาตัวจริง</label>
                        </div>
                     </form>
                  </div>
               </div>
               <div class="card">
                  <div class="card-body" [formGroup]="FormCredit">
                     <!-- Person 1 -->
                     <div class="input-group mb-3">
                        <span class="input-group-text"><mat-icon>person_add</mat-icon> คนค้ำ 1 </span>
                        <input type="text" class="form-control" placeholder="รหัสโควตาคนค้ำที่ 1"
                           formControlName="fmcodeperson1"
                           [ngClass]="{ 'is-invalid': submitted && form2.fmcodeperson1.errors }">
                        <button class="btn btn-info" (click)="CheckFarmer1();">ตรวจสอบ 1</button>
                        <mat-progress-bar mode="indeterminate" *ngIf="loadPS[1]"></mat-progress-bar>
                     </div>
                     <div *ngIf="submitted && form2.fmcodeperson1.errors?.required">
                        <p style="color: red;">กรุณาระบุโควตา</p>
                     </div>
                     <div class="input-group mb-3" *ngFor="let item of person1">
                        <span class="input-group-text"> <mat-icon>person</mat-icon></span>
                        <input type="text" class="form-control" formControlName="fmnameperson1" id="fmnameperson1">
                        <label class="input-group-text">ประเมิน {{item.Assessfm.toLocaleString('ar-TH')}} ตัน</label>
                        <label *ngIf="item.CanGet3=='N'" class="input-group-text" style="color: red;">
                           ค้ำไม่ได้ ค้ำไปแล้ว {{item.nowPromise}} คน </label>
                        <label *ngIf="item.CanGet3=='Y'" class="input-group-text">ค้ำได้</label>
                     </div>
                     <!-- Person 2 -->
                     <div class="input-group mb-3">
                        <span class="input-group-text"><mat-icon>person_add</mat-icon> คนค้ำ 2 </span>
                        <input type="text" class="form-control" placeholder="รหัสโควตาคนค้ำที่ 2"
                           formControlName="fmcodeperson2"
                           [ngClass]="{ 'is-invalid': submitted && form2.fmcodeperson2.errors }">
                        <button class="btn btn-info" (click)="CheckFarmer2();">ตรวจสอบ 2</button>
                        <mat-progress-bar mode="indeterminate" *ngIf="loadPS[2]"></mat-progress-bar>
                     </div>
                     <div *ngIf="submitted && form2.fmcodeperson2.errors?.required">
                        <p style="color: red;">กรุณาระบุโควตา</p>
                     </div>
                     <div class="input-group mb-3" *ngFor="let item of person2">
                        <span class="input-group-text"> <mat-icon>person</mat-icon></span>
                        <input type="text" class="form-control" formControlName="fmnameperson2" id="fmnameperson2">
                        <label class="input-group-text">ประเมิน {{item.Assessfm.toLocaleString('ar-TH')}} ตัน</label>
                        <label *ngIf="item.CanGet3=='N'" class="input-group-text" style="color: red;">
                           ค้ำไม่ได้ ค้ำไปแล้ว {{item.nowPromise}} คน</label>
                        <label *ngIf="item.CanGet3=='Y'" class="input-group-text">ค้ำได้</label>
                     </div>
                     <!-- Person 3 -->
                     <div class="input-group mb-3">
                        <span class="input-group-text"><mat-icon>person_add</mat-icon> คนค้ำ 3 </span>
                        <input type="text" class="form-control" placeholder="รหัสโควตาคนค้ำที่ 3"
                           formControlName="fmcodeperson3"
                           [ngClass]="{ 'is-invalid': submitted && form2.fmcodeperson3.errors }">
                        <button class="btn btn-info" (click)="CheckFarmer3();">ตรวจสอบ 3</button>
                        <mat-progress-bar mode="indeterminate" *ngIf="loadPS[3]"></mat-progress-bar>
                     </div>
                     <div *ngIf="submitted && form2.fmcodeperson3.errors?.required">
                        <p style="color: red;">กรุณาระบุโควตา</p>
                     </div>
                     <div class="input-group mb-3" *ngFor="let item of person3">
                        <span class="input-group-text"> <mat-icon>person</mat-icon></span>
                        <input type="text" class="form-control" formControlName="fmnameperson3" id="fmnameperson3">
                        <label class="input-group-text">ประเมิน {{item.Assessfm.toLocaleString('ar-TH')}} ตัน</label>
                        <label *ngIf="item.CanGet3=='N'" class="input-group-text" style="color: red;">
                           ค้ำไม่ได้ ค้ำไปแล้ว {{item.nowPromise}} คน</label>
                        <label *ngIf="item.CanGet3=='Y'" class="input-group-text">ค้ำได้</label>
                     </div>
                     <!-- Person 3 -->
                     <div class="input-group mb-3">
                        <button mat-raised-button [disabled]="t_n1!='Y'||t_n2!='Y'||t_n3!='Y'" color="primary"
                           (click)="InsertCreditWithPerson();"> บันทึกคนค้ำ
                        </button>
                     </div>
                  </div>
               </div>
            </div>

            <div class="col-lg-6">
               <div class="card">
                  <div class="card-body">
                     <table class="table">
                        <thead>
                           <th scope="col"> โควตา</th>
                           <th scope="col"> ชื่อ</th>
                           <th scope="col"> วันที่ทำสัญญา</th>
                           <th scope="col"> วันที่อัพเดทข้อมูล</th>
                        </thead>
                        <tbody>
                           <tr *ngFor="let item of tendata">
                              <td>{{item.FMCODE}}</td>
                              <td>{{item.FullName}}</td>
                              <td>{{item.DateAdd | adtob }}</td>
                              <td>{{THtoLocalstring(item.DateUpdate)}}</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
               <div class="card">
                  <div class="card-header">
                     <div class="input-group mb-3 d-flex align-items-center" [formGroup]="FormCredit">
                        <span class="input-group-text"><mat-icon>person</mat-icon> สืบค้นข้อมูลชาวไร่ </span>
                        <input class="form-control" type="text" formControlName="fmnameorcode"><button mat-raised-button
                           color="primary" (click)="Findfarmmerdata();"><mat-icon>search</mat-icon></button>
                     </div>
                  </div>
                  <div class="card-body table-responsive p-2" *ngIf="fmd_l>0" style="height: 400px">
                     <table mat-table [dataSource]="Farmerdata" matSort>
                        <ng-container matColumnDef="fmcode">
                           <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 25%;" id="KanitTH"> โควตา
                           </th>
                           <td mat-cell *matCellDef="let el"> {{el.fmcode}} </td>
                        </ng-container>
                        <ng-container matColumnDef="fmname">
                           <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 45%;" id="KanitTH"> ชื่อ
                              - สกุล </th>
                           <td mat-cell *matCellDef="let el"> {{el.fmname}} </td>
                        </ng-container>
                        <ng-container matColumnDef="zone">
                           <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;" id="KanitTH"> โซน
                           </th>
                           <td mat-cell *matCellDef="let el"> {{el.supzone}} </td>
                        </ng-container>
                        <ng-container matColumnDef="cane">
                           <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 25%;" id="KanitTH">
                              ประเมินอ้อย </th>
                           <td mat-cell *matCellDef="let el"> {{el.yield6465}} </td>
                        </ng-container>
                        <tr mat-header-row color="primary" *matHeaderRowDef="displayfarmaer ; sticky: true;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayfarmaer;"></tr>
                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                           <td class="mat-cell" colspan="4">ไม่มีข้อมูลตรงกัน "{{input.value}}"</td>
                        </tr>
                     </table>
                  </div>
               </div>
            </div>
         </div>
         <!-- หน้าเพิ่มข้อมูล -->
      </div>

      <!-- ข้อมูลทั้งหมด -->

      <div class="card" [hidden]="id!=2&&id!=3&&id!=4">
         <div class="card-body">
            <div class="row d-flex align-items-center">
               <div class="col-md">
                  <mat-checkbox [(ngModel)]="show_tel">แสดงเบอร์โทร</mat-checkbox>
                  <button mat-raised-button color="primary"
                     (click)="exportAsExcel()">โหลดข้อมูลหลักทรัพย์-ค้ำประกันในโซน</button>
               </div>
               <div class="col-md">
                  <mat-form-field appearance="standard">
                     <mat-label>ค้นหาในตาราง</mat-label>
                     <input matInput (keyup)="Filterby($event)" placeholder="ชื่อ โควตา " #input>
                  </mat-form-field>
               </div>
            </div>

            <div class="mat-elevation-z8" #TABLE>
               <table mat-table #table [dataSource]="allpromisebyzone" matSort style="width: 100%;">
                  <ng-container matColumnDef="action">
                     <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit">
                        <mat-icon>print</mat-icon>
                     </th>
                     <td mat-cell *matCellDef="let el; let i = index;">
                        <button type="button" class="btn btn-outline-success btn-sm"
                           (click)="InOrRe_list(1,{fmcode:el.FMCODE,fmname:el.fmname,dateupdate:el.DateUpdate});">
                           <i class='fa fa-plus-square' style='font-size:26;color:green'>
                           </i>
                        </button>
                     </td>
                  </ng-container>

                  <ng-container matColumnDef="count">
                     <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit"> # </th>
                     <td mat-cell *matCellDef="let el; let i = index;">{{i+1}} </td>
                  </ng-container>

                  <ng-container matColumnDef="fmcode">
                     <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit"> โควตา </th>
                     <td mat-cell *matCellDef="let el"> {{el.FMCODE}} </td>
                  </ng-container>

                  <ng-container matColumnDef="fmname">
                     <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit"> ชื่อ - สกุล </th>
                     <td mat-cell *matCellDef="let el"> {{el.fmname}}
                        <a *ngIf="(el.tel.length>8) && show_tel">(โทร-{{el.tel}})</a>
                     </td>
                  </ng-container>

                  <ng-container matColumnDef="status">
                     <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit"> ค้ำแล้ว </th>
                     <td mat-cell *matCellDef="let el"> {{el.nowpromise}} </td>
                  </ng-container>

                  <ng-container matColumnDef="promise">
                     <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit"> การค้ำประกัน/หลักทรัพย์
                     </th>
                     <td mat-cell *matCellDef="let el">
                        <p *ngIf="el.DateAdd != null">
                           <mat-label *ngIf="ck2Str(el.FmCode1)"> <span class="badge badge-primary">
                                 {{el.FmCode1}} </span>({{el.FullName1}})</mat-label>
                           <mat-label *ngIf="ck2Str(el.FmCode2)"> , <span class="badge badge-primary">
                                 {{el.FmCode2}} </span>({{el.FullName2}})</mat-label>
                           <mat-label *ngIf="ck2Str(el.FmCode3)"> , <span class="badge badge-primary">
                                 {{el.FmCode3}} </span>({{el.FullName3}})</mat-label>
                           <mat-label *ngIf="ck2Str(el.FmCode4)"> , <span class="badge badge-primary">
                                 {{el.FmCode4}} </span>({{el.FullName4}})</mat-label>
                           |
                           <mat-label *ngIf="ck2Str(el.type1)"> , ({{el.type1}}) </mat-label>
                           <mat-label *ngIf="ck2Str(el.type2)"> , ({{el.type2}}) </mat-label>
                           <mat-label *ngIf="ck2Str(el.type3)"> , ({{el.type3}}) </mat-label>
                           <mat-label *ngIf="ck2Str(el.type4)"> , ({{el.type4}}) </mat-label>
                           <mat-label *ngIf="ck2Str(el.type5)"> , ({{el.type5}}) </mat-label>
                           <mat-label *ngIf="ck2Str(el.type6)"> , ({{el.type6}}) </mat-label>
                           <mat-label *ngIf="ck2Str(el.type7)"> , ({{el.type7}}) </mat-label>
                        </p>
                     </td>
                  </ng-container>

                  <ng-container matColumnDef="dateupdate">
                     <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit" style="text-align: center;">
                        วันที่อัพเดท </th>
                     <td mat-cell *matCellDef="let el"> {{ THtoLocalstring(el.DateUpdate) }} </td>
                  </ng-container>

                  <ng-container matColumnDef="checkpromise">
                     <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit" style="text-align: center;">
                        ตรวจสัญญา </th>
                     <td mat-cell *matCellDef="let el" style="text-align: center;">
                        <mat-icon *ngIf="el.PromiseIN==1" class="bg-success">check</mat-icon>
                        <mat-icon *ngIf="el.PromiseIN!=1" class="bg-danger">clear</mat-icon>
                     </td>
                  </ng-container>
                  <!--  
                     <ng-container matColumnDef="commendBRD" >
                        <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit"> หมายเหตุ BRD </th>
                        <td mat-cell *matCellDef="let el"> {{el.brdComment}} </td>
                     </ng-container> -->

                  <tr mat-header-row style="background-color:rgb(164, 144, 255); color: black;"
                     *matHeaderRowDef="displayunckeck ; sticky: true;"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayunckeck;"></tr>

                  <!-- Row shown when there is no matching data. -->
                  <tr class="mat-row" *matNoDataRow>
                     <td class="mat-cell" colspan="4"> ไม่มีข้อมูลตรงกัน "{{input.value}}"</td>
                  </tr>
               </table>
               <mat-paginator [pageSizeOptions]="[5, 10, 25, 100, 250, 500, 1000, 2000, 5000]"
                  aria-label="Select page of users"></mat-paginator>
            </div>
         </div>
         <!-- รายการข้อมูลที่เลือก -->
         <div class="row justify-content-center" *ngIf="id != 1">
            <div class="col-5">
               <div class="card" *ngIf="choosedata.length > 0">
                  <div class="card-header">
                     <div class="d-flex justify-content-center">
                        <p style="text-align:left">รายการข้อมูลที่เลือก
                           <span class="badge bg-warning">{{choosedata.length}}</span> รายการ
                        </p>
                        &nbsp; &nbsp;
                        <!--<nav class="nav">
                           <a class="nav-link btn btn-outline-primary" role="button" aria-pressed="true"
                              [routerLink]="['/docforcredit/'+year]" routerLinkActive="active"
                              target="_blank">พิมพ์ใบปะหน้า</a>
                           &nbsp; &nbsp;
                           <a class="nav-link btn btn-outline-danger" role="button" aria-pressed="true"
                              (click)="cctest();">ล้างรายการ</a>
                        </nav>-->
                        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                           <a class="btn btn-outline-primary me-md-2" type="button"
                              [routerLink]="['/docforcredit/'+year]" routerLinkActive="active"
                              target="_blank">พิมพ์ใบปะหน้า</a>
                           <a class="btn btn-outline-danger" type="button" (click)="cctest();">ล้างรายการ</a>
                        </div>
                     </div>
                  </div>
                  <div class="card-body">
                     <table class="table table-sm" style="width:100%">
                        <thead>
                           <tr style="text-align:center">
                              <td>#</td>
                              <td>รหัสชาวไร่</td>
                              <td>ชื่อชาวไร่</td>
                              <td>วันที่บันทึก</td>
                              <td>ยกเลิก</td>
                           </tr>
                        </thead>
                        <tbody>
                           <tr *ngFor="let item of choosedata; index as i;">
                              <td style="text-align:center">{{i+1}}</td>
                              <td style="text-align:center">{{item.fmcode}}</td>
                              <td>{{item.fmname}} </td>
                              <td>{{THtoLocalstring(item.dateupdate)}} </td>
                              <td style="text-align:center">
                                 <button class="btn btn-outline-danger btn-sm"
                                    (click)="InOrRe_list(0,{fmcode:item.fmcode});">
                                    <i class='fas fa-times' style='font-size:18px;color:red'></i>
                                 </button>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </section>
</div>
<app-footer></app-footer>